'use client';

import React, { useState, useEffect } from 'react';

interface ProductImageProps {
  src?: string;
  alt: string;
  className?: string;
}

export default function ProductImage({ src, alt, className }: ProductImageProps) {
  const [error, setError] = useState(!src);
  const [loading, setLoading] = useState(true);
  const imgRef = React.useRef<HTMLImageElement>(null);

  useEffect(() => {
    setError(!src);
    setLoading(true);
  }, [src]);

  useEffect(() => {
    if (imgRef.current && imgRef.current.complete) {
      setLoading(false);
    }
  }, [src]);

  if (error) {
    return (
      <div className="absolute inset-0 bg-gray-50 flex flex-col items-center justify-center p-4 text-center select-none">
        <img 
          src="/images/pvlogo.png" 
          alt="Pasumai Virumbi" 
          className="w-10 h-10 object-contain opacity-35 mb-1" 
        />
        <span className="text-[8px] font-black uppercase tracking-widest text-deep-green/30">
          Organic Premium
        </span>
      </div>
    );
  }

  return (
    <div className="relative w-full h-full bg-white">
      {loading && (
        <div className="absolute inset-0 bg-gray-50 flex items-center justify-center">
          <div className="w-5 h-5 border-2 border-mid-green border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
      <img 
        ref={imgRef}
        src={src} 
        alt={alt} 
        className={`${className || ''} ${loading ? 'opacity-0' : 'opacity-100'} transition-opacity duration-300`}
        onLoad={() => setLoading(false)}
        onError={() => {
          setError(true);
          setLoading(false);
        }} 
      />
    </div>
  );
}
